import { ajaxJson } from 'imports/ajax';
import { createTypes } from 'redux-create-types';


const namespace = 'programs-list';

export const programsListActions = createTypes([
    'toggleSpinner',
    'setError',
    'setProgramsList'
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: programsListActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}
 
function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: programsListActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function setProgramsList(programs) {
    return dispatch => {
        dispatch({
            type: programsListActions.setProgramsList,
            payload: programs
        })
    }
}

function getProgramsApiFail(err) {
    return dispatch => {
        dispatch({
            type: programsListActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('programs'));
    }
}

function getProgramsApiSuccess(res) {
    return dispatch => {
        dispatch(setProgramsList(res.data.results));
        return dispatch(hideSpinner('programs'));
    }
}

function getProgramsFromApi() {
    return dispatch => {
        dispatch(showSpinner('programs'))
        return ajaxJson.get('/programs')
        .then(
            res => dispatch(getProgramsApiSuccess(res)),
            err => dispatch(getProgramsApiFail(err))
        )
    }
}

export const programsListActionCreators = {
    getProgramsFromApi,
}